export enum AppointmentStatus {
  NOT_VERIFIED = 'not-verified',
  WAITING_FOR_BUSINESS_APPROVAL = 'waiting-for-business-approval',
  VERIFIED = 'verified',
  // Approved by customer
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  FINISHED = 'finished',
  NO_SHOW = 'no-show',
}
